import type { StaffPositions } from '../../shared/contracts';

export function StaffPositionBadges({
  positions,
}: {
  positions: StaffPositions;
}) {
  if (positions.length === 0) return null;
  return (
    <span className="hidden items-center gap-1.5 lg:flex">
      {positions.map((position) => (
        <span
          key={position}
          className="border-standing-staff/30 text-standing-staff/85 rounded-sm border px-2 py-0.5 text-sm whitespace-nowrap"
        >
          {position}
        </span>
      ))}
    </span>
  );
}
